<template>
  <div class="mb-10">
    <div class="flex flex-col md:flex-row md:justify-between gap-4 mb-5">
      <div>
        <h2 class="text-lg text-white">Invoice Details</h2>
        <span class="text-xs text-gray-600">
          Your invoices and receipts for all payments made on your Arcweave
          account
        </span>
      </div>
      <div v-if="details">
        <EditBillingDetailsDialog :details="details" />
      </div>
    </div>
    <div v-if="isLoading">
      <Spinner />
    </div>
    <Table v-else>
      <TableBody>
        <BillingInvoiceRow>
          <template #head>Company Name</template>
          <template #cell>{{ details.companyName }}</template>
        </BillingInvoiceRow>
        <BillingInvoiceRow>
          <template #head>Address</template>
          <template #cell>{{ details.address }}</template>
        </BillingInvoiceRow>
        <BillingInvoiceRow>
          <template #head>City</template>
          <template #cell>{{ details.city }}</template>
        </BillingInvoiceRow>
        <BillingInvoiceRow>
          <template #head>State</template>
          <template #cell>{{ details.state }}</template>
        </BillingInvoiceRow>
        <BillingInvoiceRow>
          <template #head>Zip/Postal code</template>
          <template #cell>{{ details.zipCode }}</template>
        </BillingInvoiceRow>
        <BillingInvoiceRow>
          <template #head>Country</template>
          <template #cell>{{ details.country }}</template>
        </BillingInvoiceRow>
        <BillingInvoiceRow>
          <template #head>VAT ID</template>
          <template #cell>{{ details.vatId }}</template>
        </BillingInvoiceRow>
      </TableBody>
    </Table>
  </div>
</template>

<script setup>
import { Table, TableBody } from '@ui/components/table';
import Spinner from '@/ui/components/Spinner.vue';
import BillingInvoiceRow from './BillingInvoiceRow.vue';
import EditBillingDetailsDialog from './EditBillingDetailsDialog.vue';

defineProps({
  isLoading: {
    type: Boolean,
    required: false,
  },
  details: {
    type: Object,
    required: false,
    default: () => ({}),
  },
});
</script>
